import { useState } from "react";
import { HomeframeInput } from "@builtbyted/homeframe";
import { api } from "./api";

export function ViewerNameEditor({ username, name }: { username: string; name: string }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(name);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  if (!editing) return <button className="name-edit" aria-label={`Edit name for ${name || username}`} onClick={() => { setDraft(name); setError(""); setEditing(true); }}>{name ? "Edit name" : "Add name"}</button>;
  const save = async (value: string) => {
    setBusy(true); setError("");
    try {
      await api("/users/name", { username, name: value });
      setEditing(false);
    } catch (e) { setError((e as Error).message); }
    finally { setBusy(false); }
  };
  return <form className="name-editor" onSubmit={(event) => { event.preventDefault(); void save(draft); }}>
    <label>Person’s name
      <HomeframeInput autoFocus value={draft} maxLength={100} disabled={busy} placeholder="e.g. John Smith" onChange={(event) => setDraft(event.target.value)} />
    </label>
    <div className="name-editor-actions">
      <button type="submit" disabled={busy}>{busy ? "Saving…" : "Save"}</button>
      <button type="button" disabled={busy} onClick={() => setEditing(false)}>Cancel</button>
      {name && <button type="button" disabled={busy} onClick={() => void save("")}>Remove name</button>}
    </div>
    {error && <p role="alert">{error}</p>}
  </form>;
}
